import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ReportingPage } from 'pages/reporting/Reporting'
import { FC } from 'react'

const RouteComponent: FC = () => {
  const { siteId } = Route.useSearch()

  if (!siteId) {
    return <Outlet />
  }

  return <ReportingPage siteId={siteId} />
}

export const Route = createFileRoute('/reporting/')({
  component: RouteComponent,
  staticData: {
    title: 'Reporting',
    layout: {
      enableScrolling: true,
    },
  },
})
